import { useFeatureFlags } from '@node-space/hooks'
import { BusinessAddressFormData } from 'pages/Verification/BusinessAddress/BusinessAddressV1/helpers/types'
import { BusinessAddressData } from 'pages/Verification/BusinessAddress/BusinessAddressV2/helpers/types'
import { useVerificationContext } from './context/useVerificationContext'

export const useRegion = () => {
  const { enableOperationalBusinessAddress } = useFeatureFlags()
  const { businessAddress } = useVerificationContext()

  const businessCountryCode = enableOperationalBusinessAddress
    ? (businessAddress?.data as BusinessAddressData)?.registered?.countryCode
    : (businessAddress?.data as BusinessAddressFormData)?.countryCode

  return { businessCountryCode }
}
